module.exports = __webpack_public_path__ + "9b9f2c447d27a622fcb78f6b7f38a095.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/materialdesignicons-webfont.woff2?v=2.0.46
// module id = 596
// module chunks = 0